import ApiService from "../abstracts/ApiService";

class VenuesService extends ApiService {
  async getVenues() {
    const response = await this.protectedRequest({
      url: "/admin/venues",
      method: "get",
    });

    return response;
  }
}

const instance = new VenuesService();

export default instance; 